// Hash-based router (SPA friendly, no server rewrites required beyond _redirects).
// Route shapes:
//   #/         → editor (local doc)
//   #/d/<id>   → editor for doc id (loads shared state if collab present)
//   #/s/<tok>  → share resolution (fetch permission → redirect to #/d/<docId>)
import { useEffect, useState } from 'react';

export type Route =
  | { name: 'home' }
  | { name: 'doc'; docId: string }
  | { name: 'share'; token: string };

export const parseRoute = (): Route => {
  const h = typeof window !== 'undefined' ? window.location.hash : '';
  if (!h || h === '#' || h === '#/') return { name: 'home' };
  const parts = h.replace(/^#\//, '').split('/');
  if (parts[0] === 'd' && parts[1]) return { name: 'doc', docId: parts[1] };
  if (parts[0] === 's' && parts[1]) return { name: 'share', token: parts[1] };
  return { name: 'home' };
};

export const navigate = (to: Route): void => {
  const hash =
    to.name === 'home'
      ? '#/'
      : to.name === 'doc'
      ? `#/d/${encodeURIComponent(to.docId)}`
      : `#/s/${encodeURIComponent(to.token)}`;
  window.location.hash = hash;
};

export const useRoute = (): Route => {
  const [route, setRoute] = useState<Route>(() => parseRoute());
  useEffect(() => {
    const onChange = () => setRoute(parseRoute());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
};
